module.exports = __webpack_public_path__ + "img/room2.b06e1639.png";